import React from "react";
import { Link } from "react-router-dom";
import dateFormat from "dateformat";
import { LazyLoadImage } from "react-lazy-load-image-component";
const ListSingleItems = ({ data }) => {
  const SingleData = data?.gift;

  if(!data?.gift){
    return;
  }
  return (
    <>
      <div className="mobile-news-lists-item">
        <LazyLoadImage
          alt="img"
          effect="blur"
          src={`https://api.wlffinance.org/${SingleData?.image}`}
        />
        <div className="news-content">
          <h4>
            {(SingleData?.title).slice(0, 70)}{" "}
            {(SingleData?.title).length >= 70 && "....."}
          </h4>
          <p>
            {SingleData?.short_dis
              ? SingleData.short_dis.slice(0, 150) +
                (SingleData.short_dis.length >= 150 ? " ....." : "")
              : ""}
          </p>
          <span>
            Posted On {dateFormat(SingleData?.createdAt, "mmmm dd, yyyy")}
          </span>
          <Link to={`/user/gift/details/${SingleData?._id}`}>Read More</Link>
        </div>
      </div>
    </>
  );
};

export default ListSingleItems;
